import { BaseContainerModel } from '../base-container.model';
import { bl_wms_packing_list_stock_link_RowInterface, bl_wms_packing_list_stock_link_RowClass } from '../../dbschema/index';

export class WmsPackingListStockLinkContainer extends BaseContainerModel {
    bl_wms_packing_list_stock_link: bl_wms_packing_list_stock_link_RowInterface = new bl_wms_packing_list_stock_link_RowClass();
}
